'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseMenu = function BaseMenu(_ref) {
  var position = _ref.position,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    { className: 'quiver-base-menu quiver-base-menu--open-' + position },
    children
  );
};

BaseMenu.propTypes = {
  position: _propTypes2.default.string,
  children: _propTypes2.default.node
};

BaseMenu.defaultProps = {
  children: null,
  position: 'left'
};

exports.default = BaseMenu;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/BaseMenu/BaseMenu.js
// module id = 522
// module chunks = 11